import { ENVIRONMENT } from "../config";

const perPage = (defaultValue = 25, devValue = 10) =>
	ENVIRONMENT === "DEVELOPER" ? devValue : defaultValue;
export default perPage;
